'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMotion = require('react-motion');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The markup Information for an event Line. You can stack multiple lines on top of eachother
 *
 * @param  {object} props The props from parent, styling and positioning
 * @return {StatelessFunctionalReactComponent} Markup Information for the event line.
 */
var EventLine = function EventLine(_ref) {
  var left = _ref.left,
      width = _ref.width,
      fillingMotion = _ref.fillingMotion,
      backgroundColor = _ref.backgroundColor;
  return _react2.default.createElement(
    _reactMotion.Motion,
    { style: {
        tWidth: (0, _reactMotion.spring)(width, fillingMotion),
        tLeft: (0, _reactMotion.spring)(left, fillingMotion)
      } },
    function (_ref2) {
      var tWidth = _ref2.tWidth,
          tLeft = _ref2.tLeft;
      return _react2.default.createElement('span', {
        'aria-hidden': 'true',
        className: 'timeline-eventline',
        style: {
          position: 'absolute',
          left: tLeft + 'px',
          top: 0,
          height: '100%',
          width: tWidth + 'px',
          transformOrigin: 'left center',
          backgroundColor: backgroundColor
        }
      });
    }
  );
};

EventLine.propTypes = {
  // Location and dimension
  left: _propTypes2.default.number,
  width: _propTypes2.default.number,
  // how the filling motion will look like when in action
  fillingMotion: _propTypes2.default.shape({
    stiffness: _propTypes2.default.number,
    damping: _propTypes2.default.number
  }),
  // What color the line should have
  backgroundColor: _propTypes2.default.string
};

exports.default = EventLine;


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/timeline/react-horizontal-timeline/Components/EventLine.js
// module id = 1145
// module chunks = 0